"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addConsoleInstrumentationHandler = addConsoleInstrumentationHandler;

var _logger = require("../logger.js");

var _object = require("../object.js");

var _worldwide = require("../worldwide.js");

var _handlers = require("./handlers.js");

/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addConsoleInstrumentationHandler(handler) {
  const type = 'console';
  (0, _handlers.addHandler)(type, handler);
  (0, _handlers.maybeInstrument)(type, instrumentConsole);
}

function instrumentConsole() {
  if (!('console' in _worldwide.GLOBAL_OBJ)) {
    return;
  }

  _logger.CONSOLE_LEVELS.forEach(function (level) {
    if (!(level in _worldwide.GLOBAL_OBJ.console)) {
      return;
    }

    (0, _object.fill)(_worldwide.GLOBAL_OBJ.console, level, function (originalConsoleMethod) {
      _logger.originalConsoleMethods[level] = originalConsoleMethod;
      return function (...args) {
        const handlerData = {
          args,
          level
        };
        (0, _handlers.triggerHandlers)('console', handlerData);
        const log = _logger.originalConsoleMethods[level];
        log && log.apply(_worldwide.GLOBAL_OBJ.console, args);
      };
    });
  });
}